import { FieldConstraintViolation } from "../../types";
import { tFieldName, tValidationMessage } from "../../utils/translationUtils";

interface Props {
  violations?: FieldConstraintViolation[];
  rootPath: string;
}

export const FieldViolationsView = ({ violations, rootPath }: Props) =>
  violations && violations.length > 0 ? (
    <>
      {violations.map((violation) => (
        <span key={`${violation.fieldPath}-${violation.errors.join()}`}>
          <span>
            <b>{tFieldName(rootPath, violation.fieldPath)}:</b>{" "}
          </span>
          <span>{violation.errors.map((error) => tValidationMessage(rootPath, error)).join(" ")}</span>
          <br />
        </span>
      ))}
    </>
  ) : null;
